/*
 * 释放客户管理页面 (一级页面)
 *
 * entityKey: mortgageLoan/settleLeadList -> GET /api/mis/mortgageLoan/settleLeadList
 * Controller: MortgageLoanController.settleLeadList (menuType="2")
 * Service: MortgageLoanServiceImpl.queryMortgageLoanStatPage
 * Mapper: MortgageLoanMapper.queryMortgageLoanStatPage (WHERE ld.loan_status = 'SETTLED')
 *
 * 主要功能:
 *  1. 已释放客户展示 (loan_status=SETTLED)
 *  2. 顶部统计栏 (调用 /mortgageLoan/settleLeadListSum)
 *  3. 释放客户操作 (打开 /#/releaseLead)
 *  4. 还款计划查看 (弹窗内嵌 RepaymentPlanSettle 组件)
 *  5. 客户详情查看 (打开 /#/newlead)
 */
import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import {
  ApiClient,
  displayMortgageLoanStatus,
  getLeadStatItemOpt,
  getLoanTypeItemOpt,
  getMortgageLoanStatusOpt,
  Lead,
} from "../../api/ApiClient";
import React, { useEffect, useMemo, useState } from "react";
import {
  Popover,
  Button,
  Descriptions,
  Form,
  Modal,
  Row,
  Col as RowCol,
  TabPane,
  Tabs,
  Tag,
  Toast,
  Tooltip,
  Typography,
  Table,
} from "@douyinfe/semi-ui";
import RepaymentPlanSettle from "./repaymentPlanSettle";
import {
  IconCalendarClock,
  IconHelpCircle,
  IconMinusCircle,
  IconModalStroked,
  IconBarChartHStroked,
  IconPlusCircle,
} from "@douyinfe/semi-icons";
//import IndexMortgageLoan from "./indexMortgageLoan";
import {
  formatAmountZhCn,
  formatDate,
  formatDateTime,
  renderRepaymentCountTooltip,
  renderOutMoneyAmountTooltip,
  renderLoanCountTooltip,
  renderStatDetailContent,
  splitStr,
} from "../../utils";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import "./mortgage.css";
import OutMoneyPlan from "./indexOutMoneyPlan";

let apiClient = ApiClient.getDefault();
const { Text } = Typography;

// 主组件: 已释放客户列表页面 (loan_status=SETTLED)
export default function IndexMortgageLead() {
  const [mortgageLoanShow, setMortgageLoanShow] = useState(false);
  const [leadId, setLeadId] = useState(undefined as undefined | number);
  const [planShow, setPlanShow] = useState(false);
  const [loanId, setLoanId] = useState(undefined as undefined | number);
  const [paidType, setPaidType] = useState("all");
  const [loanType, setLoanType] = useState(undefined as undefined | string);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [filterFormApi, setFilterFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [showSaveLoanModal, setShowSaveLoanModal] = useState(false);
  const [saveLoanFormApi, setSaveLoanFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [saveLoanSaving, setSaveLoanSaving] = useState(false);
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  const [queryTimes, setQueryTimes] = useState([] as any[]);
  const [showAddQueryModal, setShowAddQueryModal] = useState(false);
  const [addQueryFormApi, setAddQueryFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [addQuerySaving, setAddQuerySaving] = useState(false);
  const [selectedLead, setSelectedLead] = useState({} as any);
  const [statData, setStatData] = useState([] as any[]);
  const [statDataObj, setStatDataObj] = useState({} as any);
  const [showMortgageField, setShowMortgageField] = useState(true);
  const [showCardField, setShowCardField] = useState(false);
  const [showBorrowField, setShowBorrowField] = useState(false);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [lead, setLead] = useState(undefined as undefined | Lead);
  const [selectedLoan, setSelectedLoan] = useState({} as any);
  const [selectedLoanList, setSelectedLoanList] = useState([] as any);

  const [showLeadInfoModal, setShowLeadInfoModal] = useState(false);
  const [saveLeadInfoFormApi, setSaveLeadInfoFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [showAddInterestModal, setShowAddInterestModal] = useState(false);
  const [addInterestFormApi, setAddInterestFormApi] = useState(
    undefined as undefined | FormApi
  );
    const [outMoneyPlanShow, setOutMoneyPlanShow] = useState(false);
  

  // 列定义: Crud 表格的列配置，展示已释放客户的汇总信息
  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      showInFilter: false,
      type: ColType.NUMBER,
      hideInEdit: true,
      hideInList: true,
      hideInCreate: true,
    },

    {
      name: "客户ID",
      key: "leadId",
      width: 70,
      showInFilter: true,
      hideInList:true,
      type: ColType.NUMBER,
      hideInEdit: true,
    },
    {
      name: "客户姓名",
      key: "leadName",
      width: 80,
      type: ColType.STRING,
      hideInEdit: true,
      hideInCreate: true,
      showInFilter: true,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => detailAction(record)}
          >
            {value}({record.leadId})
          </Typography.Text>
        );
      },
    },
    {
      name: "城市",
      key: "leadCity",
      width: 50,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
      hideInEdit: true,
      hideInCreate: true,
      showInFilter: true,
    },
    {
      name: "按揭专员ID",
      key: "agentId",
      type: ColType.STRING,
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "按揭专员",
      key: "agentNames",
      width: 80,
      type: ColType.STRING,
      showInFilter: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "销售ID",
      key: "saleId",
      type: ColType.STRING,
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "销售",
      key: "saleNames",
      width: 80,
      type: ColType.STRING,
      showInFilter: true,
      hideInCreate: true,
      hideInEdit: true,
    },
     {
          name: "业务属性",
          key: "loanProperty",
          width: 80,
          type: ColType.STRING,
          showInFilter: false,
          hideInCreate: false,
          hideInEdit: false,
        },

    {
      name: "贷款数",
      key: "totalMortgageCount",
      width: 50,
      type: ColType.NUMBER,
      showInFilter: false,
      hideInCreate: true,
      hideInEdit: true,
      render: (value, record, index) => {
              return (
                <Tooltip style={{maxWidth: 450}} content={renderLoanCountTooltip(record)}>
                  <Typography.Text
                    link
                    onClick={() => {
                      openMortgageLoanModal(record.leadId, record.leadName);
                    }}
                  >
                    {value}
                  </Typography.Text>
                </Tooltip>
              );
            },
    },
    {
          name: "签约金额",
          key: "totalContractAmount",
          width: 80,
          type: ColType.NUMBER,
          render: (a) => formatAmountZhCn(a),
        },

    {
      name: "贷款金额",
      key: "totalAmount",
      width: 80,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
   
    {
      name: "计划数",
      key: "repaymentPlanCount",
      width: 60,
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openRepaymentPlanModal(record.leadId, "", "");
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
          name: "还款数",
          key: "repaymentCount",
          width: 60,
          type: ColType.NUMBER,
          render: (value, record, index) => {
            return (
              <Tooltip style={{maxWidth: 450}} content={renderRepaymentCountTooltip(record)}>
                <Typography.Text
                  link
                  onClick={() => {
                    setLeadId(record.leadId);
                    setOutMoneyPlanShow(true);
                  }}
                >
                  {value ?? 0}
                </Typography.Text>
              </Tooltip>
            );
          },
        },
         {
      name: "代过账金额",
      key: "totalHelpPaidAmount",
      width: 80,
      type: ColType.NUMBER,
      hideInList:false,
      render: (a) => formatAmountZhCn(a),
    },
    
    {
                    name: "出款金额",
                    key: "totalOutMoneyAmount",
                    width: 90,
                    type: ColType.NUMBER,
                    render: (value, record, index) => {
                        return (
                            <Tooltip style={{maxWidth: 600}} content={renderOutMoneyAmountTooltip(record)}>
                                <Typography.Text
                                    link
                                    onClick={() => {
                                        setLeadId(record.leadId);
                                        setOutMoneyPlanShow(true);
                                    }}
                                >
                                    {formatAmountZhCn(record.totalHelpPaidAmount+record.totalCardHelpPaidAmount+record.totalBorrowAmount)}
                                </Typography.Text>
                            </Tooltip>
                        );
                    },
                },
       

    {
          name: "在库时长",
          key: "inStockDays",
          width: 70,
          type: ColType.NUMBER,
        },
        {
          name: "查询天数",
          key: "queryDays",
          width: 70,
          type: ColType.NUMBER,
          render: (value, record, index) => {
           
              return (
                <>
                  <Tooltip
                    style={{
                      maxWidth: 400,
                      wordBreak: "break-all",
                      whiteSpace: "pre-wrap",
                    }}
                    content={getLeadVisitAssignLogs(record.queryTimes)}
                  >
                    {" "}
                    <Typography.Text mark>{record.queryDays}</Typography.Text>
                    
                  </Tooltip>
                </>
              );
            
          },
        },
        {
          name: "征信打印日期",
          key: "creditPrintTime",
          width: 120,
          type: ColType.NUMBER,
          render: (value, record, index) => {
            
              return (
                <>
                  <Tooltip
                    style={{
                      maxWidth: 400,
                      wordBreak: "break-all",
                      whiteSpace: "pre-wrap",
                    }}
                    content={getCreditPrintLogs(record.creditPrintTimes)}
                  >
                    {" "}
                    <Typography.Text mark>{!record.creditPrintTimes || record.creditPrintTimes.length == 0
                      ? "":splitStr(record.creditPrintTimes[record.creditPrintTimes.length-1], '|', 1)}</Typography.Text>
           
                  </Tooltip>
                </>
              );
            
          },
        },
        {
          name: "接单日期",
          key: "loanAt",
          width: 90,
          type: ColType.DATE_RANGE,
          showInFilter: true,
        },
        {
          name: "日利率",
          key: "interest",
          width: 60,
          type: ColType.STRING,
          render: (value, record, index) => {
                        return (
                            <Tooltip style={{maxWidth: 450}} content={<div>
                                贷款利率: {record.interest }<br/>
                                信用卡利率: {record.borrowInterest}<br/>
                                借款利率: {record.postingInterest }<br/>
                               
                            </div>}>
                                <Typography.Text mark>{value}</Typography.Text>
                            </Tooltip>
                        );
                    },
        },
    {
      name: "总计费用",
      key: "interestAmount",
      width: 60,
      type: ColType.STRING,
      render: (a) => formatAmountZhCn(a),
    },
  ];

  // 工具函数: 计算两个日期之间的天数差（不考虑时间部分，使用UTC避免时区影响）
  function getDateDifferenceInDays(startDate: Date, endDate: Date): number {
    // 创建不考虑时间的UTC日期（避免时区影响）
    const utcStart = Date.UTC(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );

    const utcEnd = Date.UTC(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );

    // 计算相差毫秒数并转换为天数
    const diffInMs = Math.abs(utcEnd - utcStart);
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  }

  
  // 格式化征信打印日期日志文本，用于 Tooltip 展示所有打印日期
  const getCreditPrintLogs = (creditPrintTimes: any) => {
    if (creditPrintTimes) {
      let logText = "";
      creditPrintTimes.forEach((time: any) => {
        logText = logText + time + "\r\n";
      });
      return logText;
    }
  };

  // 格式化查询日期日志文本，用于 Tooltip 展示每个查询日期及距今天数
  const getLeadVisitAssignLogs = (queryTimes: any) => {
    if (queryTimes) {
      let logText = "";
      queryTimes.forEach((time: any) => {
        //计算time到当前时间的天数
        let days = getDateDifferenceInDays(new Date(time), new Date());
        logText = logText + time + "  查询天数:" + days + "\r\n";
      });
      return logText;
    }
  };

  // 功能4: 打开还款计划弹窗
  // 弹窗内嵌 RepaymentPlanSettle 组件，传入 leadId、loanId、paidType、loanType 过滤条件
  const openRepaymentPlanModal = async (
    leadId: number,
    paidType: string,
    loanType: string
  ) => {
    if(leadId == 0){
        setLeadId(undefined);
    }else{
        setLeadId(leadId);
    }
   
    setPaidType(paidType);
    if ("BORROW" == loanType) {
      setLoanType(loanType);
    } else {
      setLoanType(undefined);
    }
    setPlanShow(true);
  };

  useEffect(() => {
    return () => {
      console.log("离开页面------------");
    };
  }, []);

  let nowDate = new Date();
  let nowDateStr = formatDateTime(nowDate);

  // 功能5: 打开客户详情页面，在新窗口中跳转到 /#/newlead 查看客户信息
  // 打开详情
  const detailAction = (a: any) => {
    const w = window.open("about:blank");
    let queryParams = {
      ...crudApi?.getQueryParams(),
      type: "all",
    };
    if (w != null) {
      //获取表格data的id列表
      const ids = crudApi?.getData()?.map((i) => i.leadId);
      const data = {
        id: a.leadId,
        ids: ids,
        viewMode: true,
        visitMode: false,
        leadFrom: "report",
        queryParams: queryParams,
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  useEffect(() => {
    //刷新统计
    initStatCountData();
  }, [statDataObj]);

  // 功能2: 查询统计数据（顶部统计栏）
  // API: GET /mortgageLoan/settleLeadListSum
  // Controller: MortgageLoanController.settleLeadListSum
  const queryStatCount = async (data: any) => {
    let params = {
      ...data,
    };
    console.log("统计报表查询参数：", params);
    apiClient
      .request("/mortgageLoan/settleLeadListSum", "GET", data)
      .then((resp) => {
        setStatDataObj(resp.data);
      });
  };

  // 将统计API返回的数据转换为 Descriptions 组件所需的格式
  // 包含: 客户数、代还计划数、支出合计、贷款代还金额、个人借款金额等
  const initStatCountData = async () => {
    console.log("统计报表返回数据：", statDataObj);
    if (!statDataObj) {
      return;
    }

    const data = [
      { key: "", value: "汇总" },
      {
        key: "客户数",
        value: statDataObj.leadCount,
      },
      {
        key: "还款笔数",
        value: statDataObj.repaymentCount
      },
      
      {
              key: "代过账金额",
              value: formatAmountZhCn(statDataObj.totalHelpPostingAmount),
            },


            {
                            key: (
                                <Tooltip
                                    style={{ maxWidth: 400 }}
                                    content={"出款金额 = 贷款代还 + 信用卡代还  + 借款金额"}
                                >出款金额
                                    <IconHelpCircle
                                        style={{
                                            color: "#E91E63",
                                        }}
                                    />
                                </Tooltip>
                            ),
                            value: formatAmountZhCn(statDataObj.totalHelpPaidAmount + statDataObj.totalCardHelpPaidAmount +  statDataObj.totalBorrowAmount)
            
                        },
         
            {
              key: "个人借款金额",
              value: formatAmountZhCn(statDataObj.totalBorrowAmount),
            },
            {
              key: "个人借款已还金额",
              value: formatAmountZhCn(statDataObj.totalReturnAmount),
            },
            {
        key: (
          <Tooltip
            style={{ maxWidth: 400 }}
            content={
              "支出合计 = 贷款代还 + 信用卡代还  + 个人借款 - 个人借款已还"
            }
          >
            支出合计
            <IconHelpCircle
              style={{
                color: "#E91E63",
              }}
            />
          </Tooltip>
        ),
        value: (
          <span
            style={{
              color: "#E91E63",
            }}
          >
            {formatAmountZhCn(statDataObj.totalExpense)}
          </span>
        ),
      },
      {
        key: "费用",
        value: formatAmountZhCn(statDataObj.interestAmount),
      },
    ];
    setStatData(data);
  };

  // 渲染顶部统计栏 Descriptions 组件
  const listSumStat = () => {
    const style = {
      boxShadow: "var(--semi-shadow-elevated)",
      backgroundColor: "var(--semi-color-bg-2)",
      borderRadius: "4px",
      padding: "5px",
      margin: "auto",
    };
    return (
      <div style={{ display: "flex", width: "100%", margin: "5px", alignItems: "center" }}>
        <Popover
          content={renderStatDetailContent(statDataObj)}
          trigger="hover"
          position="bottomLeft"
          showArrow
        >
          <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked />统计详情</a>
        </Popover>
        <Descriptions data={statData} row align={"center"} style={style} />
      </div>
    );
    
  };


  // 功能3: 释放客户操作
  // 打开新窗口 /#/releaseLead，传入客户ID和姓名
  // 新窗口中使用  组件完成释放操作
   const handleSaveLeadInfoButtonClick = (a: any, rows: any) => {
      if (rows && rows.length > 1) {
        Toast.info("只能选择一个客户");
        return;
      } else if (rows && rows.length == 1) {
    
        const w = window.open("about:blank");
        if (w != null) {
          //获取表格data的id列表
          const data = {
            id: rows[0].id,
            name: rows[0].leadName,
          };
          w.location.href =
            "/#/releaseLead?data=" +
            encodeURIComponent(JSON.stringify(data));
        }
      } else {
        //如果未选择客户
        Toast.info("请选择一个客户来操作");
        return;
      }
    };
    
  // 释放客户动作定义
  const actions: CrudAction[] = [];
  const releaseLeadAction: CrudAction = {
      name: "释放客户",
      action: handleSaveLeadInfoButtonClick,
    };

  // 按钮权限控制: 只有 agent/agent_manager/op_manager/monitor/root 角色才能看到释放客户按钮
  //------------------------------------------------按钮控制------------------------------------------------------------------
  if (
    role == "agent" ||
    role == "agent_manager" ||
    role == "op_manager" ||
    role == "monitor" ||
    role == "root"
  ) {
    actions.push(releaseLeadAction);
  }

  // 点击贷款数时，打开新窗口跳转到 /#/newleadLoan 查看客户贷款详情
  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    //setLeadId(leadId);
    //setMortgageLoanShow(true);
    //打开客户贷款
    const w = window.open("about:blank");
    if (w != null) {
      //获取表格data的id列表
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  return (
    <>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title={"还款计划"}
        fullScreen={true}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        footer={null}
        hasCancel={false}
        onCancel={() => setPlanShow(false)}
        onOk={() => setPlanShow(false)}
        visible={planShow}
      >
        <div>
          <RepaymentPlanSettle
            leadId={leadId}
            loanId={loanId}
            paidType={paidType}
            loanType={loanType}
          />
        </div>
      </Modal>
      <Modal
              icon={
                <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
              }
              title={"出款明细"}
              fullScreen={true}
              headerStyle={{
                flexShrink: 0,
                borderBottom: "1px solid var(--semi-color-border)",
              }}
              bodyStyle={{
                overflow: "auto",
                flex: 1,
              }}
              footer={null}
              hasCancel={false}
              onCancel={() => setOutMoneyPlanShow(false)}
              onOk={() => setOutMoneyPlanShow(false)}
              visible={outMoneyPlanShow}
            >
              <div>
                <OutMoneyPlan leadId={leadId} />
              </div>
            </Modal>

      <Row>
        <RowCol span={24}>{listSumStat()}</RowCol>
      </Row>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        getFilterFormApi={(crudApi, api) => {
          setFilterFormApi(api);
        }}
        canUpdate={false}
        canCreate={false}
        canDelete={false}
        name="释放客户"
        entityKey="mortgageLoan/settleLeadList"
        pageSize={50}
        actions={actions}
        select={true}
        rowActionWidth={0}
        fetchDataAfterMethod={queryStatCount}
        getRowActions={(a) => {
          //let actions = [];

          return [];
        }}
        cols={cols}
      />
    </>
  );
}
